import React from 'react'
import {Link, useParams} from 'react-router-dom'
import NavBarDropdown from './NavBarDropdown'
import {NavLink} from '../../types/app-types'
import {getNavigationPaths} from '../../services/navigation'
import BrandLogo from '../../assets/placemakr-horizontal-logo-white.png'
import {useAppSelector} from '../../store/hooks'
import {selectIsAuthenticated} from '../../store/authSlice'

interface NavBarProps {
  showAccountLinks: boolean
}

function getAccountNavLinks(accountId: string): NavLink[] {
  if (accountId) {
    const paths = getNavigationPaths(accountId)
    return [
      {
        path: paths.Home,
        label: 'Accounts Home'
      },
      {
        path: paths.Account,
        label: 'Account'
      },
      {
        path: paths.MakePayment,
        label: 'Payments'
      },
      {
        path: paths.Billing,
        label: 'Billing'
      },
      {
        path: paths.SupportRequests,
        label: 'Resident Support'
      }
    ]
  }
}

const NavBar = ({showAccountLinks}: NavBarProps) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const {id} = useParams()
  const navLinks =
    isAuthenticated && showAccountLinks ? getAccountNavLinks(id) : []

  return (
    <nav className="navbar mb-2 shadow-lg bg-neutral text-neutral-content">
      <div className="flex-none w-32 mx-4">
        <Link to="/">
          <img src={BrandLogo} />
        </Link>
      </div>
      <div className="flex-1 px-2 mx-2">
        <div className="items-stretch hidden lg:flex">
          {navLinks.map(({label, path}) => (
            <Link
              key={path}
              to={path}
              className="btn btn-ghost btn-sm rounded-btn"
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
      <div className="navbar-end">
        <NavBarDropdown navLinks={navLinks} isAuthenticated={isAuthenticated} />
      </div>
    </nav>
  )
}

export default NavBar
